<template>
  <div class="playlist">
    <PlaylistCard
      :playlist="playlist"
      :isOpen="isOpen"
      @openContent="openContent"
    />
    <PlaylistContent v-if="isOpen" :playlistId="playlist.id" />
  </div>
</template>

<script>
import PlaylistCard from './PlaylistCard.vue'
import PlaylistContent from './PlaylistContent.vue'

export default {
  name: 'Playlist',
  components: {
    PlaylistCard,
    PlaylistContent,
  },
  props: {
    playlist: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isOpen: false,
    }
  },
  methods: {
    openContent() {
      this.isOpen = !this.isOpen
    },
  },
}
</script>

<style lang="scss" scoped>
.playlist {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  flex: 1;
}
</style>
